import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { GlazingGuideDialog } from './GlazingGuideDialog';

export const GlazingGuide = () => {
  const { t } = useTranslation('checkout');
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="hyperlink" onClick={() => setOpen(true)} type="button">
        {t('framing.seeGuide')}
      </button>
      <GlazingGuideDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
